module.exports = __webpack_public_path__ + "static/Beholder_kin-d56af22781efd09a96ab5824ae5f9308.jpg";